import type { SupabaseClient } from '@supabase/supabase-js';

export type ActiveSuperAdminCheckResult =
  | { ok: true }
  | { ok: false; kind: 'not_super_admin' | 'request_error'; message?: string };

/**
 * Uses DB function public.is_super_admin() (SECURITY DEFINER, migration 51).
 * That path does not depend on RLS allowing a direct SELECT on super_admins,
 * so it matches the server truth when JWT + Active row exist.
 */
export async function checkActiveSuperAdmin(
  supabase: SupabaseClient,
  _userId: string,
): Promise<ActiveSuperAdminCheckResult> {
  const { data, error } = await supabase.rpc('is_super_admin');

  if (error) {
    console.error('[auth] is_super_admin rpc', error.message);
    return { ok: false, kind: 'request_error', message: error.message };
  }
  if (data !== true) {
    return { ok: false, kind: 'not_super_admin' };
  }
  return { ok: true };
}

export async function isActiveSuperAdmin(supabase: SupabaseClient, userId: string): Promise<boolean> {
  const r = await checkActiveSuperAdmin(supabase, userId);
  return r.ok;
}
